//import React, { useState, useEffect } from "react"
import React, { useEffect } from "react"
import { Row, Col, Table, UncontrolledTooltip } from "reactstrap"
import { withRouter, useParams } from "react-router-dom"
import PropTypes from "prop-types"
import { get, isEmpty } from "lodash"
//import { connect, useSelector, useDispatch } from "react-redux"
import { connect, useSelector } from "react-redux"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import moment from "moment"

const QuotationHistory = (props) => {
  //const [formData, setFormData] = useState([])
  const { dispatch } = props
  let { id } = useParams()

  useEffect(() => {
    dispatch(quotationAction.loadQuotationHistoryDetails({ leadId: id }))
  }, [1])

  // const { followupRecordsMetaData = [] } = followupUpdate

  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const { quotation_history = [] } = quotationUpdate

  if (quotation_history) {
    const quotationHistoryUpdated = !isEmpty(quotation_history)
      ? quotation_history.map((quotation, index) => {
          if (quotation.mode == "Edit") {
            return {
              key: index,
              id: get(quotation, "_id", ""),
              mode: get(quotation, "mode", ""),
              type: get(quotation, "type", ""),
              modifiedDateTime: quotation.createdAt
                ? moment(quotation.createdAt).format("DD-MM-YYYY HH:mm")
                : "",
              insertedBy: get(quotation, "insertedBy", ""),
              eventOriginalData: get(quotation, "originalData.service", ""),
              eventUpdatedData: get(quotation, "updatedData.service", ""),
              deliverableOriginalData: get(quotation, "originalData", ""),
              deliverableUpdatedData: get(quotation, "updatedData", ""),
              eventLoopCount:
                quotation &&
                quotation.originalData &&
                quotation.originalData.service
                  ? quotation.originalData.service.length
                  : 0,
              eventLoopRowSpanCount:
                quotation &&
                quotation.originalData &&
                quotation.originalData.service
                  ? quotation.originalData.service.length * 6
                  : 0,
              deliverableLoopCount: 1,
              deliverableRowSpanLoopCount: 6,
            }
          }
        })
      : []
    var filterQuotationHistoryUpdated =
      quotationHistoryUpdated.length > 0
        ? quotationHistoryUpdated.filter((el) => el != undefined)
        : []
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col md="12" xl="3" lg="12" sm="12" xs="12" className="mb-3">
          <p className="quote-history-head">
            Quotation History
            <span className="quote-info">
              <i
                style={{ color: "grey" }}
                id="quoteInfo"
                aria-hidden="true"
                className="fa fa-info-circle ms-1"
              ></i>
              <UncontrolledTooltip placement="right" target="quoteInfo">
                Quotation Details Description
              </UncontrolledTooltip>
            </span>
          </p>
        </Col>

        {/* history table mapping */}

        <Table bordered responsive hover className="w-100">
          <thead className="table-success">
            <th className="quote-history-table">S.No</th>
            <th className="quote-history-table" style={{ width: "180px" }}>
              Modified Date & Time
            </th>
            <th className="quote-history-table" style={{ width: "130px" }}>
              Field Name
            </th>
            <th className="quote-history-table">Old</th>
            <th className="quote-history-table">New</th>
            <th className="quote-history-table">Modified By</th>
          </thead>
          <tbody>
            {filterQuotationHistoryUpdated &&
            filterQuotationHistoryUpdated.length > 0 ? (
              filterQuotationHistoryUpdated.map((item, index) => {
                if (item.type == "deliverable") {
                  var duplicateCount = 0

                  if (
                    item.deliverableOriginalData.deliverableName !=
                    item.deliverableUpdatedData.deliverableName
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.count !=
                    item.deliverableUpdatedData.count
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.actualPrice !=
                    item.deliverableUpdatedData.actualPrice
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.quotePrice !=
                    item.deliverableUpdatedData.quotePrice
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.discount !=
                    item.deliverableUpdatedData.discount
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.finalAmount !=
                    item.deliverableUpdatedData.finalAmount
                  ) {
                    duplicateCount = duplicateCount + 1
                  }
                  if (
                    item.deliverableOriginalData.deliveryModeName !=
                    item.deliverableUpdatedData.deliveryModeName
                  ) {
                    duplicateCount = duplicateCount + 1
                  }

                  if (duplicateCount > 0) {
                    return (
                      <>
                        <tr key={index}>
                          <td rowSpan={duplicateCount + 1}>{index + 1}</td>
                          <td rowSpan={duplicateCount + 1}>
                            {item.modifiedDateTime}
                          </td>
                          <td>{"product Name"}</td>
                          <td>{item.deliverableOriginalData.productName}</td>
                          <td>{item.deliverableUpdatedData.productName}</td>
                          <td rowSpan={duplicateCount + 1}>
                            {item.insertedBy}
                          </td>
                        </tr>

                        {item.deliverableOriginalData.deliverableName !=
                        item.deliverableUpdatedData.deliverableName ? (
                          <tr>
                            <td>{"Deliverable Name"}</td>
                            <td>
                              {item.deliverableOriginalData.deliverableName}
                            </td>
                            <td>
                              {item.deliverableUpdatedData.deliverableName}
                            </td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.count !=
                        item.deliverableUpdatedData.count ? (
                          <tr>
                            <td>{"Count"}</td>
                            <td>{item.deliverableOriginalData.count}</td>
                            <td>{item.deliverableUpdatedData.count}</td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.actualPrice !=
                        item.deliverableUpdatedData.actualPrice ? (
                          <tr>
                            <td>{"Actual Price"}</td>
                            <td>{item.deliverableOriginalData.actualPrice}</td>
                            <td>{item.deliverableUpdatedData.actualPrice}</td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.quotePrice !=
                        item.deliverableUpdatedData.quotePrice ? (
                          <tr>
                            <td>{"Quote Price"}</td>
                            <td>{item.deliverableOriginalData.quotePrice}</td>
                            <td>{item.deliverableUpdatedData.quotePrice}</td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.discount !=
                        item.deliverableUpdatedData.discount ? (
                          <tr>
                            <td>{"Discount"}</td>
                            <td>{item.deliverableOriginalData.discount}</td>
                            <td>{item.deliverableUpdatedData.discount}</td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.finalAmount !=
                        item.deliverableUpdatedData.finalAmount ? (
                          <tr>
                            <td>{"Final Amount"}</td>
                            <td>{item.deliverableOriginalData.finalAmount}</td>
                            <td>{item.deliverableUpdatedData.finalAmount}</td>
                          </tr>
                        ) : (
                          ""
                        )}

                        {item.deliverableOriginalData.deliveryModeName !=
                        item.deliverableUpdatedData.deliveryModeName ? (
                          <tr>
                            <td>{"Delivery Mode"}</td>
                            <td>
                              {item.deliverableOriginalData.deliveryModeName}
                            </td>
                            <td>
                              {item.deliverableUpdatedData.deliveryModeName}
                            </td>
                          </tr>
                        ) : (
                          ""
                        )}
                      </>
                    )
                  }
                } else if (item.type == "events") {
                  var eventOriginalData = item.eventOriginalData
                  var eventUpdatedData = item.eventUpdatedData
                  for (let i = 0; i < eventOriginalData.length; i++) {
                    var duplicateEventCount = 0

                    if (
                      eventOriginalData[i].quantity !=
                      eventUpdatedData[i].quantity
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }
                    if (
                      eventOriginalData[i].actualAmount !=
                      eventUpdatedData[i].actualAmount
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }
                    if (
                      eventOriginalData[i].amount != eventUpdatedData[i].amount
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }
                    if (
                      eventOriginalData[i].discount !=
                      eventUpdatedData[i].discount
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }
                    if (
                      eventOriginalData[i].upselling !=
                      eventUpdatedData[i].upselling
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }
                    if (
                      eventOriginalData[i].totalAmount !=
                      eventUpdatedData[i].totalAmount
                    ) {
                      duplicateEventCount = duplicateEventCount + 1
                    }

                    if (duplicateEventCount > 0) {
                      return (
                        <>
                          <tr>
                            <td rowSpan={duplicateEventCount + 1}>
                              {index + 1}
                            </td>
                            <td rowSpan={duplicateEventCount + 1}>
                              {item.modifiedDateTime}
                            </td>
                            <td>{"Service"}</td>
                            <td>{eventOriginalData[i].serviceId}</td>
                            <td>{eventUpdatedData[i].serviceId}</td>
                            <td rowSpan={duplicateEventCount + 1}>
                              {item.insertedBy}
                            </td>
                          </tr>

                          {eventOriginalData[i].quantity !=
                          eventUpdatedData[i].quantity ? (
                            <tr>
                              <td>{"Quantity"}</td>
                              <td>{eventOriginalData[i].quantity}</td>
                              <td>{eventUpdatedData[i].quantity}</td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {eventOriginalData[i].actualAmount !=
                          eventUpdatedData[i].actualAmount ? (
                            <tr>
                              <td>{"Actual Amount"}</td>
                              <td>{eventOriginalData[i].actualAmount}</td>
                              <td>{eventUpdatedData[i].actualAmount}</td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {eventOriginalData[i].amount !=
                          eventUpdatedData[i].amount ? (
                            <tr>
                              <td>{"Amount"}</td>
                              <td>{eventOriginalData[i].amount}</td>
                              <td>{eventUpdatedData[i].amount}</td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {eventOriginalData[i].discount !=
                          eventUpdatedData[i].discount ? (
                            <tr>
                              <td>{"Discount"}</td>
                              <td>{eventOriginalData[i].discount}</td>
                              <td>{eventUpdatedData[i].discount}</td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {eventOriginalData[i].upselling !=
                          eventUpdatedData[i].upselling ? (
                            <tr>
                              <td>{"Upselling"}</td>
                              <td>{eventOriginalData[i].upselling}</td>
                              <td>{eventUpdatedData[i].upselling}</td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {eventOriginalData[i].totalAmount !=
                          eventUpdatedData[i].totalAmount ? (
                            <tr>
                              <td>{"Total Amount"}</td>
                              <td>{eventOriginalData[i].totalAmount}</td>
                              <td>{eventUpdatedData[i].totalAmount}</td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </>
                      )
                    }
                  }
                }
              })
            ) : (
              <tr key={0}>
                <td colSpan={6} className="text-align-center">
                  {"No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Row>
    </React.Fragment>
  )
}

QuotationHistory.propTypes = {
  dispatch: PropTypes.func,
  quotation_history: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}
const mapStateToProps = (state) => ({
  quotationProps: state.quotation.record_quotation_details,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuotationHistory)
)
